// extracted by mini-css-extract-plugin
module.exports = {"title":"KYCAMLText_title__1hS6E","amlTextContainer":"KYCAMLText_amlTextContainer__3aUHe"};